let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gj7IO")).then(() => parcelRequire('lGYvJ'));